<div
  #fabContainer
  class="fab-container"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <button
    mat-fab
    class="sd-toggler"
    [style.backgroundColor]="
      getBackgroundColor(buttonConfig?.mainButton?.color ?? 'primary')
    "
    [matTooltipDisabled]="!buttonConfig?.mainButton?.tooltip || !openOnHover"
    [matTooltip]="buttonConfig?.mainButton?.tooltip || ''"
    [matTooltipPosition]="
      buttonConfig?.tooltipPosition || defaultTootltipPosition
    "
    (click)="onMainClick()"
  >
    <mat-icon
      [@mainFabButtonIconRotation]="{
        value: isOpen ? 'open' : 'closed',
        params: { degrees: rotationDegrees }
      }"
      [style.color]="getIconColor(buttonConfig?.mainButton?.color ?? 'primary')"
      >{{ buttonConfig?.mainButton?.icon ?? "add" }}</mat-icon
    >
  </button>
  <div
    class="mini-fab-container"
    *ngIf="isOpen"
    [@speedDialStagger]="{ value: buttonConfig?.miniButtons?.length || 0 }"
  >
    <button
      *ngFor="let miniBtn of buttonConfig?.miniButtons ?? []; let i = index"
      mat-mini-fab
      class="mini-fab"
      [style.backgroundColor]="
        getBackgroundColor(buttonConfig?.miniButtonColor ?? 'primary')
      "
      [matTooltip]="miniBtn.tooltip"
      [matTooltipPosition]="buttonConfig?.tooltipPosition || 'left'"
      (click)="miniButtonClick(i)"
    >
      <mat-icon
        [style.color]="getIconColor(buttonConfig?.miniButtonColor ?? 'primary')"
        >{{ miniBtn.icon }}</mat-icon
      >
    </button>
  </div>
</div>
